import React from 'react'
import './Mission.css'
import Lottie from 'react-lottie';
import * as animationData from './Animation - 1702706112696.json';
const Vision = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <>
            <div className='mission-lottey mx-auto'>
                <Lottie className=""
                    options={defaultOptions}
                />
            </div>
        </>
    )
}

export default Vision